import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
    private localApiUrl = environment.localApiUrl;
    private apiUrl = environment.apiUrl;
    private apiKey = environment.apiKey;
    private version = environment.version;

    constructor(
      private http:HttpClient,
    ) {}

    getSchedule(server: any, platform: any, line: any, operator: any, destination: any = undefined) {

      let url = '';
      let HttpOption = {}

      if(server=='true'){

          url = this.apiUrl + "/busdata/schedules";

          if(destination != undefined && destination !=''){
            url = url + "?destination=" + destination;
          } else if(line != undefined && line != '' && operator != undefined && operator != '') {
            url = url + "?line=" + line + "&operator=" + operator;
          } else if(platform != undefined){
            url = url + "?platform=" + platform;
          }

          HttpOption = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'x-api-key': this.apiKey
            })
          };

      } else {

        url = this.localApiUrl + "/schedules";

        if(destination != undefined && destination !=''){
          url = url + "?destination=" + destination;
        } else if(line != undefined && line != '' && operator != undefined && operator != '') {
          url = url + "?line=" + line + "&operator=" + operator;
        } 

        HttpOption = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
      }

      return this.http.get(url,HttpOption)

    }

    getPlatform(){
      let url = this.localApiUrl + "/platform";

      const HttpOption = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
      return this.http.get(url,HttpOption)
    }

    getDestination(server: String = 'false'){
      let HttpOption;
      let url ='';
      if(server == 'true'){

        url = this.apiUrl + "/destinations";

        HttpOption = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'x-api-key': this.apiKey
          })
        };

      }else{

        url = this.localApiUrl + "/destinations";

        HttpOption = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
        
      }

      return this.http.get(url,HttpOption)
    }

    getDestinationStops() {
      let options = {
        headers: {
          'Content-Type': 'application/json',
        },
        observe: 'response' as 'body',
      }

      let params = {
        limit: 2000,
        origin_stop_id: 'CAVbrg_260'
      }

      return this.http.post<any>(this.apiUrl + '/busdata/gtfs/stops', params, options)
    }

    checkConection(platform: string = 'none'){
      let url = this.apiUrl + "/health/api?version=" + this.version + (platform != 'none' ? `&platform=${platform}` : '');

      const HttpOption = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
      return this.http.get(url,HttpOption)
    }

    notifyKuma(platform: string){

      let kuma = environment.monitoring.find(p => p.platform == platform)?.kuma;

      let url = `https://status.wegoshare.com/api/push/${kuma}?status=up&msg=OK&ping=`

      console.log(url);

      const HttpOption = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
      return this.http.get(url,HttpOption)
    }
  }

